import { IMeta } from '@bees-web/core/types'
import { ChangeEvent } from 'react'
import {
  rateMyServiceChange,
  rateMyServiceQuestionsChange,
} from '../../actions/ratings'

export const rateMyServiceQuestions = (dispatch, interactiveState, globalActions) => ({
  attributes: {
    onClick: (_e: ChangeEvent<HTMLInputElement>, _meta: IMeta) => {
      if (_meta?.target?.getAttribute('questionId') !== undefined) {
        const questionId = _meta?.target?.getAttribute('questionId')
        dispatch(
          rateMyServiceQuestionsChange({
            answers: [
              {
                questionId: questionId,
                responses: [_e],
              },
            ],
          })
        )
      }
    },
    onChange: (
      _e: ChangeEvent<HTMLInputElement>,
      _meta: IMeta,
      option:
        | { optionKey: string; optionValue: string }
        | { optionKey: string; optionValue: string }[]
    ) => {
      const responses = Array.isArray(option)
        ? option.map((opt) => opt.optionKey)
        : [option.optionKey]

      if (option !== undefined) {
        dispatch(
          rateMyServiceQuestionsChange({
            surveyType: _meta?.surveyType,
            answers: [
              {
                questionId: _meta?.question?.id,
                responses: responses,
              },
            ],
          })
        )
      }
      if (_e?.target?.getAttribute('questionId') != undefined) {
        const questionId = _e?.target?.getAttribute('questionId')
        const responseId = _e?.target?.id
        dispatch(
          rateMyServiceQuestionsChange({
            answers: [
              {
                questionId: questionId,
                responses: [responseId],
              },
            ],
          })
        )
      }
    },
  },
})

export const rateMyServiceQuestionsStars = (
  dispatch,
  interactiveState,
  globalActions
) => ({
  attributes: {
    onSaveRating: (score: number, meta: IMeta) => {
      dispatch(rateMyServiceChange({ subtitle: meta.currentKey }))
      dispatch(
        rateMyServiceChange({
          subtitle: meta.currentElement.options[score - 1].optionValue,
        })
      )
      dispatch(
        rateMyServiceQuestionsChange({
          answers: [
            {
              questionId: meta?.questionId,
              responses: [`ticket_rated_${score}`],
            },
          ],
        })
      )
    },
  },
})
